
import {IntPropertyConfig, PropertyType, StringPropertyConfig } from "msg-properties-client-web/dist/generated";

export const trackColumns = ['priority', 'name', 'imo', 'callSign', 'length', 'width', 'start', 'end', 'pointCount']